import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const HOURS = Array.from({ length: 12 }, (_, i) => String(i + 1));
const MINUTES = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));

const parse = (v) => {
  if (!v) return { h: "", m: "", ap: "AM" };
  const [H, M] = v.split(":").map(Number);
  return { h: String(H % 12 || 12), m: String(M).padStart(2, "0"), ap: H >= 12 ? "PM" : "AM" };
};

const build = ({ h, m, ap }) => {
  if (!h) return "";
  const H = (Number(h) % 12) + (ap === "PM" ? 12 : 0);
  return `${String(H).padStart(2, "0")}:${m || "00"}`;
};

export function TimePicker({ value, onChange, testId }) {
  const t = parse(value);
  const set = (patch) => onChange(build({ ...t, ...patch }));
  return (
    <div className="flex items-center gap-1.5" data-testid={testId}>
      <Select value={t.h || undefined} onValueChange={(h) => set({ h })}>
        <SelectTrigger className="h-10 w-[68px] px-2.5" data-testid={`${testId}-hour`}><SelectValue placeholder="hr" /></SelectTrigger>
        <SelectContent className="max-h-64">{HOURS.map((h) => <SelectItem key={h} value={h}>{h}</SelectItem>)}</SelectContent>
      </Select>
      <span className="text-slate-400">:</span>
      <Select value={t.h ? t.m : undefined} onValueChange={(m) => set({ m, h: t.h || "9" })}>
        <SelectTrigger className="h-10 w-[68px] px-2.5" data-testid={`${testId}-minute`}><SelectValue placeholder="min" /></SelectTrigger>
        <SelectContent className="max-h-64">{MINUTES.map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}</SelectContent>
      </Select>
      <div className="flex rounded-md border h-10 overflow-hidden shrink-0">
        {["AM", "PM"].map((ap) => (
          <button
            key={ap}
            type="button"
            onClick={() => set({ ap, h: t.h || "9" })}
            className={`px-2.5 text-xs font-semibold transition-colors ${t.h && t.ap === ap ? "bg-primary text-white" : "bg-white text-slate-600 hover:bg-secondary"}`}
            data-testid={`${testId}-${ap.toLowerCase()}`}
          >
            {ap}
          </button>
        ))}
      </div>
    </div>
  );
}
